import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Tab, Tabs, Form } from "react-bootstrap";
import {
  LegendFieldComponent,
  LegendTextareaComponent,
  IconFieldComponent,
} from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import { BASE_URL, CURRENT_IP, TOKEN } from "../../helper/BASE_URL";
import axios from "axios";

export default function MyAccountPage() {

  const { t } = useContext(TranslatorContext);

  const [getDataas, setGetDataas] = useState("");

  useEffect(() => {
    Handle_Enter_OTP();
  }, []);

  const Handle_Enter_OTP = () => {
    const getData = localStorage.getItem("jwt");
    const parseIt = JSON.parse(getData);

    try {
      axios
        .post(
          BASE_URL + "get_user_profile.php",
          {
            userid: parseIt.reg_em,
            token: parseIt.boss_token,
            ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);
          setGetDataas(acc.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{t("my_account")}</h3>
            </div>
          </div>
        </Col>
        <Col xl={12}>
          <div className="mc-card">
            <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
              <Tab eventKey="profile" className="mc-tabpane profile">
                <div className="mc-tab-card">
                  <h6 className="mc-tab-card-title">
                    {t("BossPanda Profile Details")}
                  </h6>
                  <Row>
                    <Col xl={4}>
                      <LegendFieldComponent
                        className="mb-4"
                        type="text"
                        title={t("Email")}
                        value={getDataas && getDataas.userid}
                      />
                    </Col>
                    <Col xl={4}>
                      <LegendFieldComponent
                        className="mb-4"
                        type="text"
                        title={t("Name")}
                        value={getDataas && getDataas.name}
                      />
                    </Col>
                    <Col xl={4}>
                      <LegendFieldComponent
                        className="mb-4"
                        type="text"
                        title={t("Country")}
                        value={getDataas && getDataas.country}
                      />
                    </Col>
                    <Col xl={4}>
                      <LegendFieldComponent
                        className="mb-4"
                        type="text"
                        title={t("Contact Number")}
                        value={getDataas && getDataas.mobile}
                      />
                    </Col>
                    <Col xl={4}>
                      <LegendFieldComponent
                        className="mb-4"
                        type="text"
                        title={t("Joining Date")}
                        value={getDataas && getDataas.reg_date}
                      />
                    </Col>
                    <Col xl={4}>
                      <LegendFieldComponent
                        className="mb-4"
                        type="text"
                        title={t("sponsor userid")}
                        value={getDataas && getDataas.sponsor_userid}
                      />
                    </Col>
                    <Col xl={4}>
                      <LegendFieldComponent
                        className="mb-4"
                        type="text"
                        title={t("sponsor name")}
                        value={getDataas && getDataas.sponsor_name}
                      />
                    </Col>
                   
                  </Row>
                </div>
                
              </Tab>

            </Tabs>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}
